module.exports = __webpack_public_path__ + "img/javascript.95757ba9.jpg";